<template>
  <ModalDialog
    header-text="Product Application Form"
    contentClass="application-modal-content"
    :canBeClosed="!formSubmitting"
    @closeModal="closeModal"
    open
  >
    <template v-slot:content>
      <ProductApplicationForm
        :plants="plants"
        @closeForm="onFormClosed"
        @submittingChanged="(value: boolean) => (formSubmitting = value)"
      />
    </template>
  </ModalDialog>
</template>

<script setup lang="ts">
import type { IdAndName } from "@/Domain/IdAndName";
import ModalDialog from "@/shared/ui/modal/ModalDialog.vue";
import { ref } from "vue";
import { useNotificationStore } from "@/stores/useNotificationStore";
import { NotificationTypeEnum } from "@/Domain/NotificationTypeEnum";
import ProductApplicationForm from "./ProductApplicationForm.vue";

const notificationStore = useNotificationStore();

defineProps<{
  plants: IdAndName[];
}>();

const emit = defineEmits<{
  (e: "closeModal"): void;
}>();

const formSubmitting = ref(false);

const onFormClosed = () => {
  emit("closeModal");
};

const closeModal = function (closed: boolean) {
  if (formSubmitting.value || !closed) {
    notificationStore.notify({
      type: NotificationTypeEnum.info,
      message: "Please wait while products are being added to the cart",
      duration: 5000,
    });
    return;
  }
  emit("closeModal");
};
</script>

<style lang="scss">
.application-modal-content {
  max-width: 700px;
  padding: 2rem;
  margin: 0 -20px;
}
</style>
